import { render, staticRenderFns } from "./SaveCancelDiscard.vue?vue&type=template&id=0691a242&lang=pug&"
import script from "./SaveCancelDiscard.vue?vue&type=script&lang=ts&"
export * from "./SaveCancelDiscard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SaveCancelDiscard.vue"
export default component.exports